<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						狀態圖示
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">狀態圖示</h3>
				<div class="row">
					<div class="col">
						<p>點擊出現說明</p>
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="攻擊上升" data-content="角色物理攻擊力上升" class="icon-status cursor-pointer pa-up"></span>
						攻擊上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔攻上升" data-content="該角色魔法攻擊力上升" class="icon-status cursor-pointer ma-up"></span>
						魔攻上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="防禦上升" data-content="該角色物理防禦力上升" class="icon-status cursor-pointer pd-up"></span>
						防禦上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔防上升" data-content="該角色魔法防禦力上升" class="icon-status cursor-pointer md-up"></span>
						魔防上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物爆上升" data-content="該角色物理爆擊率上升" class="icon-status cursor-pointer pc-up"></span>
						物爆上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="吸收上升" data-content="該角色下次攻擊會吸收HP" class="icon-status cursor-pointer hs-up"></span>
						吸收上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="回復上升" data-content="提高回復的回復量" class="icon-status cursor-pointer hl-up"></span>
						回復上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="ＴＰ上升" data-content="提高TP上升這個行為的上升量" class="icon-status cursor-pointer tp-up"></span>
						ＴＰ上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="迴避上升" data-content="提高迴避機率" class="icon-status cursor-pointer sp-up"></span>
						迴避上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="行動上升" data-content="減少下一個動作的間隔" class="icon-status cursor-pointer mv-up"></span>
						行動上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物爆傷上升" data-content="物理爆擊傷害上升" class="icon-status cursor-pointer v2 pcd-up"></span>
						物爆傷<br>上升
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔爆傷上升" data-content="魔法爆擊傷害上升" class="icon-status cursor-pointer v2 mcd-up"></span>
						魔爆傷<br>上升
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="攻擊下降" data-content="角色物理攻擊力下降" class="icon-status cursor-pointer pa-down"></span>
						攻擊下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔攻下降" data-content="該角色魔法攻擊力下降" class="icon-status cursor-pointer ma-down"></span>
						魔攻下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="防禦下降" data-content="該角色物理防禦力下降" class="icon-status cursor-pointer pd-down"></span>
						防禦下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔防下降" data-content="該角色魔法防禦力下降" class="icon-status cursor-pointer md-down"></span>
						魔防下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物爆下降" data-content="該角色物理爆擊率下降" class="icon-status cursor-pointer pc-down"></span>
						物爆下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="吸收下降" data-content="減少該角色下次攻擊吸收HP的回復量" class="icon-status cursor-pointer hs-down"></span>
						吸收下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="回復下降" data-content="減少回復的回復量" class="icon-status cursor-pointer hl-down"></span>
						回復下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="ＴＰ下降" data-content="減少TP上升這個行為的上升量" class="icon-status cursor-pointer tp-down"></span>
						ＴＰ下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="迴避下降" data-content="該角色迴避機率下降" class="icon-status cursor-pointer sp-down"></span>
						迴避下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="行動下降" data-content="增加下一個動作的間隔" class="icon-status cursor-pointer mv-down"></span>
						行動下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物爆傷下降" data-content="物理爆擊傷害下降" class="icon-status cursor-pointer v2 pcd-down"></span>
						物爆傷<br>下降
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔爆傷下降" data-content="魔法爆擊傷害下降" class="icon-status cursor-pointer v2 mcd-down"></span>
						魔爆傷<br>下降
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="麻痺" data-content="使該角色無法行動 當前行動會被打斷" class="icon-status cursor-pointer paralyzed"></span>
						麻痺
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="暈眩" data-content="使該角色無法行動 當前行動會被打斷" class="icon-status cursor-pointer stun"></span>
						暈眩
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="束縛" data-content="使該角色無法行動 當前行動會被打斷" class="icon-status cursor-pointer chain"></span>
						束縛
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="冰凍" data-content="使該角色無法行動 當前行動會被打斷" class="icon-status cursor-pointer freeze"></span>
						冰凍
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="睡眠" data-content="使該角色無法行動 睡眠中被攻擊傷害提高" class="icon-status cursor-pointer sleepy"></span>
						睡眠
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="黑暗" data-content="提高該角色物理攻擊會出現MISS的機率" class="icon-status cursor-pointer blind"></span>
						黑暗
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="沉默" data-content="使該角色只能普攻" class="icon-status cursor-pointer silence"></span>
						沉默
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魅惑" data-content="使該角色攻擊我方" class="icon-status cursor-pointer charm"></span>
						魅惑
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="混亂" data-content="使該角色攻擊我方" class="icon-status cursor-pointer confuse"></span>
						混亂
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="無敵" data-content="該角色不會收到傷害" class="icon-status cursor-pointer invincible"></span>
						無敵
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="挑釁" data-content="使敵方攻擊施放挑釁的角色" class="icon-status cursor-pointer taunt"></span>
						挑釁
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="千里眼" data-content="使敵人下次所使用的物理攻擊，使其變成必定能迴避的狀態。" class="icon-status cursor-pointer clairvoyance"></span>
						千里眼
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="火傷" data-content="每秒受到傷害" class="icon-status cursor-pointer burn"></span>
						火傷
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="詛咒" data-content="每秒受到傷害" class="icon-status cursor-pointer curse"></span>
						詛咒
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="毒" data-content="每秒受到傷害" class="icon-status cursor-pointer poison"></span>
						毒
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="反射傷害" data-content="反射受到的傷害" class="icon-status cursor-pointer v2 reflect"></span>
						反射傷害
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="攻擊無效" data-content="使所有攻擊無效" class="icon-status cursor-pointer pm-invalid"></span>
						攻擊無效
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物理無效" data-content="使物理攻擊無效" class="icon-status cursor-pointer p-invalid"></span>
						物理無效
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔法無效" data-content="使魔法攻擊無效" class="icon-status cursor-pointer m-invalid"></span>
						魔法無效
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="攻擊吸收" data-content="吸收敵方的攻擊轉成HP" class="icon-status cursor-pointer pm-steal"></span>
						攻擊吸收
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="物理吸收" data-content="吸收敵方的物理攻擊轉成HP" class="icon-status cursor-pointer p-steal"></span>
						物理吸收
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="魔法吸收" data-content="吸收敵方的魔法攻擊轉成HP" class="icon-status cursor-pointer m-steal"></span>
						魔法吸收
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="畏懼" data-content="克蘿依的技能 依據堆疊數量造成相應的傷害" class="icon-status cursor-pointer v2 lollipop"></span>
						畏懼
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="露娜的朋友" data-content="顯示露娜朋友的數量" class="icon-status cursor-pointer v2 lunafriend"></span>
						露娜朋友
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="英靈" data-content="以自身為中心，使範圍內我方全體獲得英靈之加護，並且中幅度提升其魔法攻擊力，小幅度提升行動速度。" class="icon-status cursor-pointer v2 armor"></span>
						英靈
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="硬幣" data-content="克莉絲提娜（聖誕節）。 使用必殺技將會獲得硬幣，依照其有無則能在輔助與攻擊 兩種定位進行切換" class="icon-status cursor-pointer v2 coin"></span>
						硬幣
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="ＴＰ緩回" data-content="每秒回復TP" class="icon-status cursor-pointer v2 healer2"></span>
						ＴＰ緩回
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="HP緩回" data-content="每秒回復HP" class="icon-status cursor-pointer v2 healer"></span>
						HP緩回
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="恐慌" data-content="該角色無法獲得TP" class="icon-status cursor-pointer v2 sadface"></span>
						恐慌
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="騎士之加護" data-content="當貪吃佩可的所剩的HP不滿50%時，賦予自己騎士之加護。若在擁有著騎士之加護時HP歸零，將不會被擊倒而是消耗加護同時恢復HP。" class="icon-status cursor-pointer v2 crown"></span>
						騎士加護
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="傷害上限技能" data-html="true" data-content="所謂的【傷害上限技能】，指的是公會戰Boss於戰鬥開始時使用的技能。<br>
						角色的普通攻擊、技能或是UB等等，單次行動所造成的傷害值若是高於「850000」，則將根據給予的傷害值，減少對Boss的傷害量。<br />
						※上述技能效果無法於戰鬥中被解除。<br>
						※上述技能效果將適用於物理攻擊及魔法攻擊。<br>
						※不適用於Boss召喚出的怪獸。<br />
						※公會戰所有階段的Boss皆會使用此技能。" class="icon-status cursor-pointer v2 limit"></span>
						傷害上限技能
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="切嚕" data-content="琪愛兒 每當造成暴擊時將會累積【切嚕】，【切嚕】最多只能追加 30 個。" class="icon-status cursor-pointer v2 cheru"></span>
						切嚕
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="切嚕" data-content="琪愛兒 每當造成暴擊時將會累積【切嚕】，【切嚕】最多只能追加 30 個。" class="icon-status cursor-pointer v2 cheru2"></span>
						切嚕
					</div>					
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 likefire"></span>
						???
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 acorn"></span>
						???
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 chaindown"></span>
						???
					</div>
				</div>
				<div class="row mb-3">
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 ghost"></span>
						???
					</div>
					<div class="col text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 deer"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 chainatk"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 clock"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 aim-up"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 aim-down"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 starlove"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 crosswind"></span>
						???
					</div>
					<div class="col-1 text-center icon-status-box">
						<span data-toggle="popover" data-placement="bottom" title="???" data-content="不明" class="icon-status cursor-pointer v2 windarrow"></span>
						???
					</div>
					<div class="col"></div>
					<div class="col"></div>
					<div class="col"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'StatusEffect',
	data() {
		return {}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '狀態圖示',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	methods: {
		getDungeon: function(dungeon_Id) {}
	},
	computed: {},
	mounted: function() {
		$(document).ready(function() {
			$('[data-toggle="popover"').popover({html : true});
			$('[data-toggle="popover"').on('click', function(e) {
				$('[data-toggle="popover"').not(this).popover('hide');
			});
		});
	}
}
</script>
<style scoped>
</style>